import { ButtonTypes } from "../../../../../../components/ui/Button";
import ProgressIndicatorModel from "../../../../../../components/widgets/ProgressIndicator/ProgressIndicator_model";
import I18n from "../../../../../../core/localization/I18n";
import ModalContext from "../../../../../../core/modalZ/context/ModalContext";
import { UiActionRenderers } from "../../../../../../core/uiAction/IUiAction";
import OrganisationsApi from "../../../../../../services/api/v2/organisations/Organisations.api";
import UsersApi from "../../../../../../services/api/v2/users/Users.api";
import { SingleFormModel } from "../../../../../change/forms/singleFormModel/SingleForm_model";
import { GetCreateOrganisationFields } from "./CreateOrganisation_fields";

export class CreateOrganisationModel {
  formModel: SingleFormModel;
  modalService = ModalContext;
  httpProgress = ProgressIndicatorModel;
  orgProvider = OrganisationsApi;
  organisationId: number;

  constructor(organisationId: number) {
    this.organisationId = organisationId;
    this.formModel = new SingleFormModel();

    this.formModel.formFields = this.generateFormFields();
    this.formModel.actions = [
      {
        id: "cancel",
        label: I18n.t("phrases.cancel"),
        rendersIn: UiActionRenderers.BUTTON,
        onAction: () => {
          this.modalService.hide();
        },
        componentProps: {
          type: ButtonTypes.LINK,
          className: "ml-auto"
        }
      },
      {
        id: "save",
        label: I18n.t("phrases.save"),
        onAction: async () => {
          let res = await this.formModel.submit();
          if (res) {
            this.httpProgress.showOverlay();
            const result = await this.orgProvider.createByAdmin(this.organisationId, res as any);
            this.httpProgress.hideOverlay();

            if (!result || result.isError) {
              return;
            }
            this.modalService.hide();
          }
        },
        rendersIn: UiActionRenderers.BUTTON,
        componentProps: {
          type: ButtonTypes.PRIMARY,
          className: "ml-2"
        }
      }
    ];
  }

  generateFormFields = () => {
    return GetCreateOrganisationFields(UsersApi, this.organisationId);
  };
}
